import React, { useRef, useEffect, useState } from 'react';
import { MapContainer, TileLayer, GeoJSON, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './style.css';
import { getBoundsFromGeoJson } from '/src/services/ProcessingData/ProcessGeoJsonForDisplay';

// Component for bounds changes and GeoJSON layers
function MapContent({ bounds, parsedParentGeoJson, parsedChildGeoJson, getBoundsFrom }) {
    const map = useMap();
    const parentRef = useRef();
    const childRef = useRef();

    const boundsPaddingIfChild = [10,10]
    const boundsPaddingIfParent = [2,2]
    
    useEffect(() => {
        if (bounds) {
            const boundsToUse = getBoundsFrom === 'parent' ? boundsPaddingIfParent : boundsPaddingIfChild;
            map.fitBounds(bounds, {
                padding: boundsToUse,
                maxZoom: 10,        // Prevent too much zoom when fitting bounds
                animate: true
            });
        }
    }, [bounds, map]);

    useEffect(() => {
        if (parentRef.current) {
            parentRef.current.clearLayers();
            if (parsedParentGeoJson) {
                parentRef.current.addData(parsedParentGeoJson);
            }
        }
    }, [parsedParentGeoJson]);

    useEffect(() => {
        if (childRef.current) {
            childRef.current.clearLayers();
            if (parsedChildGeoJson) {
                childRef.current.addData(parsedChildGeoJson);
            }
        }
    }, [parsedChildGeoJson]);

    return (
        <>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <GeoJSON
                ref={parentRef}
                data={parsedParentGeoJson}
                style={{
                    color: '#000000',
                    weight: 1,
                    fillColor: '#f0f0f0',
                    fillOpacity: 0.6
                }}
            />
            <GeoJSON
                ref={childRef}
                data={parsedChildGeoJson}
                style={{
                    color: '#115453',
                    weight: 2,
                    fillColor: '#115453',
                    fillOpacity: 0.3
                }}
            />
        </>
    );
}

const MapVisualization = ({ parentGeoJson, childGeoJson, getBoundsFrom = 'child' }) => {
    const [bounds, setBounds] = useState(getBoundsFromGeoJson(childGeoJson) || [[34.0522, -118.2437], [34.0522, -118.2437]]);
    const [parsedParent, setParsedParent] = useState(null);
    const [parsedChild, setParsedChild] = useState(null);

    useEffect(() => {
        const newParent = typeof parentGeoJson === 'string' ? JSON.parse(parentGeoJson) : parentGeoJson;
        // console.log('NEW PARENT', newParent);
        setParsedParent(newParent);
        if (getBoundsFrom === 'parent') {
            const newBounds = getBoundsFromGeoJson(parentGeoJson);
            if (newBounds) {
                setBounds(newBounds);
            }
        }
    }, [parentGeoJson]);

    useEffect(() => {
        const newChild = typeof childGeoJson === 'string' ? JSON.parse(childGeoJson) : childGeoJson;
        // console.log('NEW CHILD', newChild);
        setParsedChild(newChild);
        if (getBoundsFrom === 'child') {
            const newBounds = getBoundsFromGeoJson(childGeoJson);
            if (newBounds) {
                setBounds(newBounds);
            }
        }
    }, [childGeoJson]);

    return (
        <div className="climate-map-container">
            <MapContainer
                bounds={bounds}
                className="climate-map box-shadow-standard"
                attributionControl={false}
                // minZoom={8}
                // maxZoom={13}
                zoomControl={false}
                scrollWheelZoom={false}
                dragging={false}
            >
                <MapContent 
                    bounds={bounds}
                    parsedParentGeoJson={parsedParent}
                    parsedChildGeoJson={parsedChild}
                    getBoundsFrom={getBoundsFrom}
                />
            </MapContainer>
        </div>
    );
};

export default MapVisualization;